import { useEffect, useState } from "react";

export function useMenuPosition(menuOpen, anchorRef) {
  const [menuPos, setMenuPos] = useState({ top: 0, right: 32 });

  useEffect(() => {
    if (!menuOpen) return undefined;
    const syncMenuPosition = () => {
      if (!anchorRef.current) return;
      const rect = anchorRef.current.getBoundingClientRect();
      setMenuPos({
        top: rect.bottom + 8,
        right: Math.max(window.innerWidth - rect.right, 12),
      });
    };
    syncMenuPosition();
    window.addEventListener("resize", syncMenuPosition);
    window.addEventListener("scroll", syncMenuPosition, true);
    return () => {
      window.removeEventListener("resize", syncMenuPosition);
      window.removeEventListener("scroll", syncMenuPosition, true);
    };
  }, [anchorRef, menuOpen]);

  return menuPos;
}
